// Cordova build (build:cordova) set PUBLIC_URL=. để asset resolve tương đối trong WKWebView
// (app không chạy ở origin https://..., path tuyệt đối "/images/..." sẽ resolve sai).
// Mọi asset tĩnh trong public/ (images, logo...) tham chiếu từ JS phải qua helper này thay vì hardcode "/...".
export const publicAsset = (path) => `${process.env.PUBLIC_URL}${path}`
